require('./emailEditor.i18n.json');
require('./emailEditor.less');
require('./emailEditor.tpl.html');
require('./emailEditorController');
require ('./propertiesFilter');
const EmailEditorComponent = {
    templateUrl: '/emailEditor.tpl.html',
    controller: 'emailEditorController',
    bindings: {
        selectedEmailAttachments: '<',
        availableEmailAttachments: '<',
        isEmailAttachmentDropdownOpen: '<',
        options:'<',
        showAttachment:'<',
        showFooter:'<',
        readOnly:'<',
        isModeUms:'<',
        userList:'<',
        closePopup:'&',
        handleUploadAttachmentEmail:'&',
        loadEmailAttachments:'&'
    }
};

angular.module('gw-um-email-editor')
    .component('uiEmailEditor', EmailEditorComponent);
